import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// 初回DOM生成時にCDNから bootstrap を読み込む
document.addEventListener('DOMContentLoaded', () => {
  // <head> 内に追記
  document.head.insertAdjacentHTML('beforeend', `<link rel="stylesheet" href="${environment.bootstrapUrl}">`);
});

if (environment.production) {
  enableProdMode();
} else {
  console.log('%c[development] ON', 'color: blue');
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
